import React, { useEffect, useState } from "react";
import axios from "axios"; // Import axios for API requests
import { useSelector } from "react-redux";
import {
  getWeatherBackgroundColor,
  getWeatherDescription,
} from "../../utils/weather"; // Ensure this path is correct
import { Card, CardContent, Grid, Typography } from "@mui/material";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import WbSunnyIcon from "@mui/icons-material/WbSunny"; // Example icon for weather conditions
import CloudIcon from "@mui/icons-material/Cloud";
import AirIcon from "@mui/icons-material/Air";
import LoadingBox from "../indicators/LoadingBox";
import { LightGreyBox } from "../styled";
import { StyledBadge } from "../styled/badge";
import { getTextColorByBackgroundContrast } from "../../extras"; // Ensure this path is correct

const WeatherDisplay = () => {
  const deliveryCenterLat = useSelector(
    (state) => state.deliveryCenter.deliveryCenter?.lat || 0
  );
  const deliveryCenterLng = useSelector(
    (state) => state.deliveryCenter.deliveryCenter?.lng || 0
  );

  const [weatherData, setWeatherData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWeatherData = async (latitude, longitude) => {
      const url = `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`;

      try {
        const response = await axios.get(url);
        setWeatherData(response.data.current_weather);
      } catch (err) {
        console.log(err);
        setError("Failed to fetch weather data");
      } finally {
        setLoading(false);
      }
    };

    if (deliveryCenterLat && deliveryCenterLng) {
      fetchWeatherData(deliveryCenterLat, deliveryCenterLng);
    }
  }, [deliveryCenterLat, deliveryCenterLng]);

  if (loading) return <LoadingBox height={100} />;
  if (error) return <Typography>{error}</Typography>;

  const backgroundColor = getWeatherBackgroundColor(weatherData.weathercode);

  const weatherIcon =
    weatherData.weathercode === 0 ? (
      <WbSunnyIcon
        sx={{ color: getTextColorByBackgroundContrast(backgroundColor) }}
      />
    ) : (
      <CloudIcon
        sx={{ color: getTextColorByBackgroundContrast(backgroundColor) }}
      />
    );

  return (
    <Card
      variant="outlined"
      sx={{
        padding: 2,
        borderRadius: 2,
      }}
    >
      <CardContent>
        <Grid container spacing={1} justifyContent="center">
          <Grid item xs={12}>
            <StyledBadge
              sx={{
                mb: 1,
                display: "flex",
                backgroundColor: backgroundColor,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {weatherIcon}
              <Typography
                variant="h6"
                sx={{
                  ml: 1,
                  color: getTextColorByBackgroundContrast(backgroundColor),
                }}
              >
                {getWeatherDescription(weatherData.weathercode)}
              </Typography>
            </StyledBadge>
            <LightGreyBox
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <DeviceThermostatIcon sx={{ mr: 1 }} />
              <Typography variant="h6">
                Temperatura: {weatherData.temperature}°C
              </Typography>
            </LightGreyBox>
          </Grid>
          <Grid item xs={12}>
            <LightGreyBox
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <AirIcon sx={{ mr: 1 }} />
              <Typography variant="h6">
                Vento: {weatherData.windspeed} km/h
              </Typography>
            </LightGreyBox>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default WeatherDisplay;
